// extracted by mini-css-extract-plugin
export default {"card":"drinkdetail_card__ZVs75","img":"drinkdetail_img__Ck4TL","title":"drinkdetail_title__dUvpf"};